import NBType from '@netbase/nb-type'

/**
 * @typedef {object} NodSentenceInfoSchema
 * @property {string} documentFingerprint
 * @property {string} nodFingerprint
 * @property {string} sentenceFingerprint
 * @property {string} sentenceNumber
 */
const NodSentenceInfoSchema = NBType.object().shape('NodSentenceInfoSchema', {
  /* @prop */
  documentFingerprint: NBType.string(),
  /* @prop */
  nodFingerprint: NBType.string(),
  /* @prop */
  sentenceFingerprint: NBType.string(),
  /* @prop */
  sentenceNumber: NBType.string() /* END */
})
export default NodSentenceInfoSchema
// RESERVE BELOW
